export default {"src":"/_next/static/media/regulatory-compliance.7c085d13.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};